import React, { ReactNode } from 'react';
import { Global } from '@emotion/core';

import { uniqueId } from 'lodash';
import { ModalDialog } from '../ModalDialog';
import { FLOW_MODAL_HEADER_PADDING, FLOW_MODAL_WIDTH } from './constants';

// I tried to use ModalDialogWrappingComp to style the modal, but didn't work
// for this case unfortunately
const MODAL_CLASSNAME = uniqueId('flow-modal-');

// TODO: move this to styles.ts and fix type errors
const StylingForModal = (
  <Global
    styles={{
      [`body .${MODAL_CLASSNAME}`]: {
        maxWidth: FLOW_MODAL_WIDTH,

        // rounded corners at the bottom
        'modal-dialog': {
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'calc(100vh - 160px)',

          '.react-modal-header': {
            padding: FLOW_MODAL_HEADER_PADDING,
          },
        },

        '@media (min-width: 1635px)': {
          'modal-dialog': {
            maxHeight: 'calc(100vh - 80px)',
          },
        },

        // removed the default paddings
        '.react-modal-footer': {
          display: 'none',
        },
        '.react-modal-body': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          overflow: 'hidden',
          padding: 0,
        },
      },
    }}
  />
);

export interface FlowModalProps {
  title: string;
  children: ReactNode;
  showClose?: boolean;
  onHide: () => void;
}

export const FlowModal = React.memo(
  ({ title, children, showClose, onHide }: FlowModalProps) => {
    return (
      <>
        {StylingForModal}
        <ModalDialog
          show
          showClose={showClose}
          onHide={onHide}
          dialogClassName={MODAL_CLASSNAME}
          title={title}
        >
          {children}
        </ModalDialog>
      </>
    );
  }
);
